import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import OpenInterestFull from './open-interest-full';

const OpenInterestFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <OpenInterestFull {...props} />
    </QueryClientProvider>
  );
};

export { OpenInterestFullWidget }
